/*jshint esversion: 6 */
// import Vue from 'vue';
// import axios from 'axios';
//
// import router from '@/router/index';
//
// import {comparePosition, extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  //statistics
  statistic_settings: {
    value: 'workpackages',
    pep_value: 'none',
    cumulative: false,
    filter: false,
    trains: [],
    milestones: [],
    colors: [],
    icons: [],
    status: [],
  },
  statistic_settings_cache: { value: '', height: 0 },
  error: '',
  statistics_loading: false,
});

// State object
const state = initialState();
const getters = {
  //Getters to UltraStore state
  getStatistics: (state, getters, rootState, rootGetters) => (project_id) => {
    let statistics = { max_takt_sum: 0, takt_values: [] };
    let takt_sum = 0;
    let values = [];
    let calendar = rootGetters['ProjectCalendar/getCalendar'](project_id);
    for (let takt_index = 0; takt_index < rootGetters['Project/getProjectLength'](project_id); takt_index++) {
      let payload = { project_id: project_id, takt_index: takt_index, trains: [], milestones: [], colors: [], icons: [], status: [] };
      if (state.statistic_settings.filter === true) {
        payload.trains = state.statistic_settings.trains;
        payload.milestones = state.statistic_settings.milestones;
        payload.colors = state.statistic_settings.colors;
        payload.icons = state.statistic_settings.icons;
        payload.status = state.statistic_settings.status;
      }
      let workpackages = rootGetters['Train/getWorkpackagesInTakt'](payload);
      // if (workpackages.length !== 0) {
      //Workpackge_Count
      if (state.statistic_settings.value === 'workpackages') {
        if (state.statistic_settings.pep_value !== 'none') {
          // is pep value
          let relevant_status = ['ready', 'started', 'done', 'checked', 'closed'];
          let color = 'grey lighten-2';
          let icon = 'checked-stopwatch';
          let tooltip = 'ready+';
          switch (state.statistic_settings.pep_value) {
            case 'started':
              relevant_status.splice(0, 1);
              color = 'grey lighten-1';
              icon = 'plane-takeoff';
              tooltip = 'started+';
              break;
            case 'done':
              relevant_status.splice(0, 2);
              color = 'grey darken-1';
              icon = 'check-large';
              tooltip = 'done+';
              break;
            case 'checked':
              relevant_status.splice(0, 3);
              icon = 'thumbs-up';
              color = 'grey darken-2';
              tooltip = 'checked+';
              break;
            case 'closed':
              relevant_status.splice(0, 4);
              color = 'grey darken-3';
              icon = 'close';
              tooltip = 'closed+';
              break;
          }
          if (state.statistic_settings.cumulative && takt_index > 0) {
              //is cumulative
              takt_sum = statistics.takt_values[takt_index - 1].takt_sum + workpackages.length;
              values = [];
              // "other"
              values.push({
                value: statistics.takt_values[takt_index - 1].values[0].value,
                color: '',
                tooltip: '',
                icon: 'checkbox-radial-empty'
              });
              // status
              values.push({
                value: statistics.takt_values[takt_index - 1].values[1].value,
                color: color,
                tooltip: tooltip,
                icon: icon
              });
            } else {
              //is not cumulative
              takt_sum = workpackages.length;
              values = [];
              // "other"
              values.push({
                value: 0,
                color: '',
                tooltip: '',
                icon: 'checkbox-radial-empty'
              });
              // status
              values.push({
                value: 0,
                color: color,
                tooltip: tooltip,
                icon: icon
              });
            }
          // increase workpackage counts...
          workpackages.forEach(workpackage => {
            if (workpackage.stop_status === 'none') {
              // only consider work packages that are not on stop...
              if (relevant_status.includes(workpackage.status)) {
                // if work package status is relevant, increase count...
                // values should only have 1 entry... so we increase the last one..
                values[values.length - 1].value++;
              } else {
                values[0].value++;
              }
            }
          });
        } else {
          // is not pep value
          if (state.statistic_settings.cumulative && takt_index > 0) {
            //is cumulative
            takt_sum = statistics.takt_values[takt_index - 1].takt_sum + workpackages.length;
            values = [];
            rootState.Ultra.status_array.forEach((status, index) => {
              values.push({
                value: statistics.takt_values[takt_index - 1].values[index].value,
                color: status.color,
                tooltip: status.tooltip,
                icon: status.icon
              });
            });
            // stop_status
            values.push({
              value: statistics.takt_values[takt_index - 1].values[statistics.takt_values[takt_index - 1].values.length - 1].value,
              color: 'red',
              tooltip: 'Stop',
              icon: 'exclamation-triangle-negative'
            });
          } else {
            //is not cumulative
            takt_sum = workpackages.length;
            values = [];
            rootState.Ultra.status_array.forEach(status => {
              values.push({
                value: 0,
                color: status.color,
                icon: status.icon,
                tooltip: status.tooltip
              });
            });
            // stop_status
            values.push({
              value: 0,
              tooltip: 'Stop',
              color: 'red',
              icon: 'exclamation-triangle-negative'
            });
          }
          // increase workpackage counts for each status...
          workpackages.forEach(workpackage => {
            if (workpackage.stop_status !== 'none') {
              values[values.length - 1].value++;
            } else if (workpackage.status === 'stop') {
              //nothing
            } else {
              values[rootState.Ultra.status_array.findIndex(status => status.name === workpackage.status)].value++;
            }
          });
        }

      }
      //Calendar
      else if (state.statistic_settings.value === 'calendar') {
        //is cumulative?
        if (state.statistic_settings.cumulative && takt_index > 0) {
          //nothing
        } else {
          takt_sum = 0;
          values = [];
          if (workpackages.length !== 0 && calendar.takt_times.length !== 0) {
            let week_days_sorted = rootGetters['ProjectCalendar/getWeekDaysSorted'](project_id);
            let dates = calendar.takt_times[takt_index].dates;
            for (let i = 0; i < week_days_sorted.length; i++) {
              let day = week_days_sorted[i];
              let value = '';
              if (dates.find(date => rootState.Ultra.week_days[date.getDay()] === day)) {
                value = day + ' ' + dates.find(date => rootState.Ultra.week_days[date.getDay()] === day).toISOString().substring(8, 10);
              }
              values.push({
                value: value,
                color: '',
                tooltip: '',
              });
            }
          } else {
            for (var i = 0; i < 7; i++) {
              values.push({
                value: '',
                color: '',
                tooltip: '',
              });
            }
          }
        }
        takt_sum = values.length;
      }
      // machine steps
      else if (state.statistic_settings.value === 'tmachine_step_count') {
        if (state.statistic_settings.cumulative && takt_index > 0) {
          // cumulative
          takt_sum = statistics.takt_values[takt_index - 1].takt_sum;
          values = [];
          rootState.Ultra.machinestep_types.forEach(machine_type => {
            values.push({
              value: 0,
              color: machine_type.color,
              tooltip: machine_type.text,
              icon: machine_type.icon
            });
          });

        } else {
          // non cumulative
          takt_sum = 0;
          values = [];
          rootState.Ultra.machinestep_types.forEach(machine_type => {
            values.push({
              value: 0,
              color: machine_type.color,
              tooltip: machine_type.text,
              icon: machine_type.icon
            });
          });
        }

        // increase values for each work package matching the step types...
        workpackages.forEach(workpackage => {
          if('tmachine_step_count' in workpackage){
            takt_sum += workpackage.tmachine_step_count;
          } else {
            takt_sum += workpackage.wbmachine_step_count;
          }

          values[rootState.Ultra.machinestep_types.findIndex(machine_type => machine_type.value === 'Tower Crane')].value += workpackage.tower_crane_count;
          values[rootState.Ultra.machinestep_types.findIndex(machine_type => machine_type.value === 'Mobile Crane')].value += workpackage.mobile_crane_count;
          values[rootState.Ultra.machinestep_types.findIndex(machine_type => machine_type.value === 'Lifting Platform')].value += workpackage.lifting_platform_count;
          values[rootState.Ultra.machinestep_types.findIndex(machine_type => machine_type.value === 'Inclined Lift')].value += workpackage.inclined_lift_count;
          values[rootState.Ultra.machinestep_types.findIndex(machine_type => machine_type.value === 'Elevator')].value += workpackage.elevator_count;
          values[rootState.Ultra.machinestep_types.findIndex(machine_type => machine_type.value === 'Construction Elevator')].value += workpackage.construction_elevator_count;
          values[rootState.Ultra.machinestep_types.findIndex(machine_type => machine_type.value === 'Truck')].value += workpackage.truck_count;
          values[rootState.Ultra.machinestep_types.findIndex(machine_type => machine_type.value === 'Pallet Truck')].value += workpackage.pallet_truck_count;
          values[rootState.Ultra.machinestep_types.findIndex(machine_type => machine_type.value === 'Forklift')].value += workpackage.forklift_count;
          values[rootState.Ultra.machinestep_types.findIndex(machine_type => machine_type.value === 'Laydown Area')].value += workpackage.laydown_area_count;
          values[rootState.Ultra.machinestep_types.findIndex(machine_type => machine_type.value === 'Container')].value += workpackage.container_count;
          values[rootState.Ultra.machinestep_types.findIndex(machine_type => machine_type.value === 'Concrete Mixer')].value += workpackage.concrete_mixer_count;
          values[rootState.Ultra.machinestep_types.findIndex(machine_type => machine_type.value === 'Excavator')].value += workpackage.excavator_count;
        });


      }
      //Workpackage Values
      else {
        let tooltip = state.statistic_settings.value;
        switch (tooltip) {
          case 'costs_budget_total':
            tooltip = 'Total Budget';
            break;
          case 'costs_tendered_total':
            tooltip = 'Total Tendered Costs';
            break;
          case 'costs_paid_out_total':
            tooltip = 'Total Paid out Costs';
            break;
          case 'costs_budget_labour':
            tooltip = 'Budget Labour';
            break;
          case 'costs_tendered_labour':
            tooltip = 'Tendered Labour Costs';
            break;
          case 'costs_paid_out_labour':
            tooltip = 'Paid out Labour Costs';
            break;
          case 'costs_budget_material':
            tooltip = 'Budget Material';
            break;
          case 'costs_tendered_material':
            tooltip = 'Tendered Material Costs';
            break;
          case 'costs_paid_out_material':
            tooltip = 'Paid out Material Costs';
            break;
        }
        
        //is cumulative?
        if (state.statistic_settings.cumulative && takt_index > 0) {
          takt_sum = statistics.takt_values[takt_index - 1].takt_sum;
          values = [];
          rootGetters['TWorkPackage/getTWorkpackageColors'].forEach((color, index) => {
            values.push({
              value: statistics.takt_values[takt_index - 1].values[index].value,
              color: color.value,
              tooltip: tooltip,
            });
          });
        } else {
          takt_sum = 0;
          values = [];
          rootGetters['TWorkPackage/getTWorkpackageColors'].forEach(color => {
            values.push({
              value: 0,
              color: color.value,
              tooltip: tooltip,
            });
          });
        }
        workpackages.forEach(workpackage => {
          let addition;
          if (['duration_planned', 'time_effort_planned'].includes(state.statistic_settings.value)) {
            let time_effort;
            if (workpackage.time_effort_source === 'time_effort_planned') {
              time_effort = workpackage.time_effort_planned;
            } else if (workpackage.tworksteps.length === 0) {
              time_effort = workpackage.time_effort_steps;
            } else {
              time_effort = rootGetters['ProjectStructure/calcAllWorkStepsTotal']({ workpackage: workpackage, prefix: 't' }).value;
            }

            if (state.statistic_settings.value === 'duration_planned') {
              if (workpackage.manpower_planned !== 0) {
                addition = Math.round((time_effort / workpackage.manpower_planned) * 100) / 100;
              } else {
                addition = 0;
              }
            }
            else if (state.statistic_settings.value === 'time_effort_planned') {
              addition = time_effort;
            }
          }
          else if (['duration_actual', 'time_effort_actual', 'manpower_actual'].includes(state.statistic_settings.value)) {
            let takt_report = {
              manpower: 0,
              duration: 0,
              time_effort: 0,
              date: 'TAKT'
            };
            let dailyreports = rootGetters['Ultra/getUObjects']({ type: 'dailyreports', ids: workpackage.dailyreports });
            dailyreports.forEach(report => {
              takt_report.manpower += report.manpower;
              takt_report.duration += report.duration;
              takt_report.time_effort += (report.manpower * report.duration);
            });
            if (dailyreports.length !== 0) {
              takt_report.manpower = Math.round((takt_report.manpower / dailyreports.length) * 100) / 100;
            } else {
              takt_report.manpower = 0;
            }
            if (state.statistic_settings.value === 'duration_actual') {
              // addition = Math.round((workpackage.duration_actual*workpackage.manpower_actual)*100) / 100;
              addition = takt_report.duration;
            } else if (state.statistic_settings.value === 'time_effort_actual') {
              addition = takt_report.time_effort;
            } else if (state.statistic_settings.value === 'manpower_actual') {
              addition = takt_report.manpower;
            }
          }
          //all other values
          else {
            if (state.statistic_settings.value.includes('step_count')) {
              // steps...
              if(state.statistic_settings.value in workpackage){
                // is tworkpackage
                addition = workpackage[state.statistic_settings.value];
              } else {
                // is wb workpackage; only works because there are only 2 types of work packages...
                addition = workpackage[state.statistic_settings.value.replace('t', 'wb')];
              }

            } else {
              addition = workpackage[state.statistic_settings.value];
            }
          }
          values[values.findIndex(value => value.color === workpackage.color)].value += addition;
          takt_sum = parseFloat(takt_sum) + parseFloat(addition);
        });
        // Calendar
      }
      //update max_takt_sum
      if (takt_sum > statistics.max_takt_sum) {
        statistics.max_takt_sum = takt_sum;
      }
      // write takt_value
      statistics.takt_values.push({ takt_sum: takt_sum, values: values });
    }
    // else {
    // statistics.takt_values.push({takt_sum: takt_sum, values: [{value: 0, color: ''}]});
    // }
    // }

    // update tooltips
    statistics.takt_values.forEach(takt_value => {
      takt_value.values.forEach(value => {
        // tooltip string + value
        value.tooltip = `${value.tooltip}: ${value.value}`;
      });
    });


    return statistics;
  },
  getStatisticSettings: (state) => {
    return state.statistic_settings;
  },
};
// Actions
const actions = {
  //local Statistics variables
  setStatisticSettings({ commit, dispatch }, payload) {
    if ([
      'time_effort_planned',
      'image_count',
      'autopilotissue_count',
      'log_entry_count',
      'tcost_step_count',
      'tdefect_step_count',
      'tdesign_step_count',
      'thandover_step_count',
      'tlogistic_step_count',
      'tmaterial_step_count',
      'tmachine_step_count',
      'tquality_step_count',
      'twork_step_count',
    ].includes(payload.value)
    ) {
      commit('set_statistics_loading', true);
      dispatch('Ultra/requestUObject', {
        url: [
          { projects: payload.project_id },
          { flexbar: '' }
        ]
      }, { root: true }).then(() => {
        commit('set_statistic_settings', payload);
        commit('set_statistics_loading', false);
      });
    } else {
      commit('set_statistic_settings', payload);
    }
  },
  resetStatisticSettings({ commit }) {
    var payload = {
      value: 'workpackages',
      pep_value: 'none',
      cumulative: false,
      filter: false,
      trains: [],
      milestones: [],
      colors: [],
      icons: [],
      status: [],
    };
    commit('set_complete_statistic_settings', payload);
  },
  resetFilter({ commit }) {
    commit('reset_filter_settings');
  }
};
// Mutations
const mutations = {
  //local state mutations
  set_statistic_settings(state, payload) {
    if (payload.setting === 'value2' || payload.setting === 'value3') {
      payload.setting = 'value';
    }

    if (payload.setting === 'value' || payload.setting === 'cumulative') {
      if ([
        'manpower_planned',
        'manpower_actual',
        'time_effort_planned',
        'time_effort_actual',
        'calendar',
      ].includes(payload.value)) {
        state.statistic_settings.cumulative = false;
      }
      state.statistic_settings[payload.setting] = payload.value;
    } else if (payload.setting === 'filter') {
      state.statistic_settings.filter = !state.statistic_settings.filter;
      if (state.statistic_settings.colors.length +
        state.statistic_settings.icons.length +
        state.statistic_settings.status.length +
        state.statistic_settings.trains.length  +
        state.statistic_settings.milestones.length === 0
      ) {
        state.statistic_settings.filter = false;
      }
    } else if (payload.setting === 'pep_value') {
        state.statistic_settings.pep_value = payload.value;
    } else {
      let index = state.statistic_settings[payload.setting].findIndex(setting => setting === payload.value);
      if (index === -1) {
        state.statistic_settings.filter = true;
        state.statistic_settings[payload.setting].push(payload.value);
      } else {
        state.statistic_settings[payload.setting].splice(index, 1);
        if (state.statistic_settings.colors.length +
          state.statistic_settings.icons.length +
          state.statistic_settings.status.length +
          state.statistic_settings.trains.length +
          state.statistic_settings.milestones.length === 0
        ) {
          state.statistic_settings.filter = false;
        }
      }
    }
  },
  set_statistic_settings_cache(state) {
    state.statistic_settings_cache.value = state.statistic_settings.value;
  },
  set_statistic_train_insert(state, id) {
    state.statistic_settings.trains.splice(0, state.statistic_settings.trains.length, parseInt(id));
    state.statistic_settings.filter = true;
  },
  set_complete_statistic_settings(state, payload) {
    state.statistic_settings = payload;
  },
  reset_filter_settings(state) {
    state.statistic_settings.trains = [];
    state.statistic_settings.milestones = [];
    state.statistic_settings.colors = [];
    state.statistic_settings.icons = [];
    state.statistic_settings.status = [];
  },
  set_statistics_loading(state, loading) {
    state.statistics_loading = loading;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
